import styled, { css } from "styled-components";
import { colors } from "../../../../../../consts";
import { WrapperContainer } from "../../../../../../components";

export const ChangeHistoryListWrapper = styled(WrapperContainer)`
  height: ${(props) => (props?.isAdminUser ? "176px" : "264px")};

  margin-left: -24px;
  width: calc(100% + 48px);
  padding: 0 24px;
  position: relative;
`;

export const ChangeHistoryListStyled = styled(WrapperContainer)`
  overflow-y: auto;
  padding-bottom: 16px;

  ::-webkit-scrollbar-track-piece {
    margin-block-start: ${(props) => (props?.isScrolledTop ? 0 : "54px")};
  }
`;

export const FirstItemWrapper = styled(WrapperContainer)`
  width: 100%;
  margin-left: -24px;
  padding-left: 24px;
`;

const AbsoluteContainerScrolledStyle = css`
  background: ${colors.WHITE};
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.16);
`;

export const AbsoluteContainer = styled(WrapperContainer)`
  position: absolute;
  top: 0;
  width: 100%;
  padding-left: 24px;
  margin-left: -24px;
  background: transparent;
  z-index: 1;
  box-shadow: "0px 4px 6px -1px rgba(0, 0, 0, 0)";
  transition: 0.3s box-shadow;

  ${(props) => !props?.isScrolledTop && AbsoluteContainerScrolledStyle};
`;

export const BottomBorder = styled(WrapperContainer)`
  width: 100%;
  height: 10px;
  padding-left: 24px;
  margin-left: -24px;
  position: absolute;
  bottom: -16px;
  box-shadow: 0px -4px 6px -2px rgba(0, 0, 0, 0.16);

  opacity: ${(props) => (props?.isScrolledBottom ? 0 : 1)};
  transition: 0.3s opacity;
`;
